import React, { createContext, useContext } from "react";

const TabsContext = createContext();

export function Tabs({ children, defaultValue, onValueChange }) {
    const [value, setValue] = React.useState(defaultValue);
    const handleChange = (v) => {
        setValue(v);
        onValueChange?.(v);
    };
    return (
        <TabsContext.Provider value={{ value, onChange: handleChange }}>
            {children}
        </TabsContext.Provider>
    );
}

export function TabsList({ children, className }) {
    return <div className={className}>{children}</div>;
}

export function TabsTrigger({ value, children, className = "" }) {
    const { value: active, onChange } = useContext(TabsContext);
    const isActive = active === value;

    return (
        <button
            className={
                `
        inline-block w-auto
        px-4 py-2
        transition-colors duration-150 ease-in-out
        rounded-md
        shadow-inner
        bg-gray-100 text-gray-700
        focus:outline-none focus:ring-2 focus:ring-gray-100 cursor-pointer
        ${className}
        ${
                    isActive
                        ? "font-bold border-b-2 border-gray-400 bg-gray-200 text-gray-900"
                        : "hover:bg-gray-200 hover:text-gray-800"
                }
      `
            }
            onClick={() => onChange(value)}
        >
            {children}
        </button>
    );
}

export function TabsContent({ value, children }) {
    const { value: active } = useContext(TabsContext);
    return active === value ? <div>{children}</div> : null;
}
